import {
  Navigate,
  Route,
  Routes,
} from "react-router-dom";


import WebsiteLayout
  from "../modules/website/components/layout/WebsiteLayout";


import HomePage
  from "../modules/website/pages/HomePage";

import AboutPage
  from "../modules/website/pages/AboutPage";

import ContactPage
  from "../modules/website/pages/ContactPage";

import ProductsPage
  from "../modules/website/pages/ProductsPage";

import ProductOverviewPage
  from "../modules/website/pages/ProductOverviewPage";


const WebsiteRoutes = () => {

  return (
    <Routes>

      {/* WEBSITE LAYOUT */}

      <Route
        element={
          <WebsiteLayout />
        }
      >

        {/* HOME */}

        <Route
          path="/"
          element={
            <HomePage />
          }
        />


        {/* ABOUT */}

        <Route
          path="/about"
          element={
            <AboutPage />
          }
        />


        {/* CONTACT */}

        <Route
          path="/contact"
          element={
            <ContactPage />
          }
        />


        {/* PRODUCTS */}

        <Route
          path="/products"
          element={
            <ProductsPage />
          }
        />


        {/* PRODUCT OVERVIEW */}

        <Route
          path="/products/:slug"
          element={
            <ProductOverviewPage />
          }
        />

      </Route>


      {/* UNKNOWN WEBSITE ROUTE */}

      <Route
        path="*"
        element={
          <Navigate
            to="/"
            replace
          />
        }
      />

    </Routes>
  );

};


export default WebsiteRoutes;